import React from 'react'
import { connect } from 'react-redux'

import * as Styled from './styled'

/* eslint-disable no-shadow */
interface Props {
  error: string
}

export const ErrorComponent: React.FunctionComponent<Props> = ({ error }) => {
  return <span role="alert">{error !== '' && <Styled.Alert>{error}</Styled.Alert>}</span>
}

const mapStateToProps = (state) => ({
  error: state.error,
})

export default connect(mapStateToProps)(ErrorComponent)
